import { Component } from '@angular/core';

@Component({
    selector: 'app-expansion-panel-body',
    templateUrl: './expansion-panel-body.component.html',
    styleUrls: ['./expansion-panel-body.component.scss'],
    standalone: false
})
export class ExpansionPanelBodyComponent {
}